import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetTiltControlOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getTiltControlOptions: GetTiltControlOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { tilt_control },
  } = baseProduct;
  return tilt_control ? tilt_control : [];
};
